import RawTextField, { RawTextDefaultProps } from './components/RawTextField.js';
import React__default from 'react';
import { NumberFieldSize } from './constants.js';

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
var INT_REGEX = /\d*/;
var FLOAT_REGEX = /\d{1,}(\.)?\d*/;

var removeNonNumbers = function removeNonNumbers(value, regexToUse) {
  var updated = value.match(regexToUse);
  return updated && updated[0];
};
/**
 * The NumberField is a field used to allow user to type only numbers
 * between a mix and a max value.
 *
 * In its current form, it only allows for positive integer values. Typing "-"
 * in the field is not allowed. Floats using a single decimal separator
 * of '.' are also allowed.
 *
 * Be aware that NumberField only allows for `min` to be a number between 0 and 9.
 * Any number greater than that will fail the validation when entering the
 * first number (ie: if min was set to 20, and user starts typing "5" in the
 * input, the validation currently sees this as inferior to 20 and prevents
 * the field update)
 */


var NumberField = /*#__PURE__*/function (_React$PureComponent) {
  _inherits(NumberField, _React$PureComponent);

  var _super = _createSuper(NumberField);

  function NumberField(props) {
    var _this;

    _classCallCheck(this, NumberField);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "isNumberWithinBounds", function (value) {
      // note: casting all these as number to avoid messing with this logic becasue they can technically be undefined
      var _this$props = _this.props,
          min = _this$props.min,
          max = _this$props.max;
      var hasMin = min >= 0;
      var hasMax = max >= 0;
      return !hasMin && !hasMax || hasMax && !hasMin && value <= max || hasMin && !hasMax && value >= min || hasMin && hasMax && value <= max && value >= min;
    });

    _defineProperty(_assertThisInitialized(_this), "handleChange", function (value, event) {
      var validValue = _this.getValidValue(value);

      if (validValue !== null) {
        _this.props.onChange(validValue, event, parseFloat(validValue));
      }
    });

    _defineProperty(_assertThisInitialized(_this), "formatValue", function (value) {
      var newValue = _this.getValidValue(value);

      if (typeof value === 'number' && _this.props.allowFloats) {
        // eslint-disable-next-line no-console
        console.warn("Warning! We notice that you're setting `value` to a number type and you have `allowFloats` set to true. If you are saving the input value as a number in state, your user may be unable to type a decimal separator. We recommend setting the `value` to a string, and using the third `numValue` parameter in the `onChange` params for your change handler's number-type specific needs");
      }

      return newValue === null ? '' : newValue;
    });

    _defineProperty(_assertThisInitialized(_this), "getValidValue", function (value) {
      var stringOfNumbers;

      if (typeof value === 'number') {
        stringOfNumbers = value.toString();
      } else {
        stringOfNumbers = removeNonNumbers(value, _this.props.allowFloats ? FLOAT_REGEX : INT_REGEX);
      } // If the string has no numbers in it, we return an empty string
      // as we allow the user to clear the field.


      if (!stringOfNumbers) {
        return '';
      } // If the number is within bounds, we return the parsed string.


      var parsedNumbers = parseFloat(stringOfNumbers);

      if (_this.isNumberWithinBounds(parsedNumbers)) {
        return stringOfNumbers;
      } // If the number is not within bounds we return `null` to indicate
      // that the value is not valid, which we'll use to prevent any update
      // of the value in the field.


      return null;
    });

    if (props.min && props.max && props.min > props.max) {
      console.warn('Min should be smaller than Max'); // eslint-disable-line no-console
    }

    return _this;
  }

  _createClass(NumberField, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          value = _this$props2.value,
          _this$props2$isResize = _this$props2.isResizeable,
          isResizeable = _this$props2$isResize === void 0 ? RawTextDefaultProps.isResizeable : _this$props2$isResize,
          _this$props2$size = _this$props2.size,
          size = _this$props2$size === void 0 ? RawTextDefaultProps.size : _this$props2$size,
          _this$props2$isRounde = _this$props2.isRounded,
          isRounded = _this$props2$isRounde === void 0 ? RawTextDefaultProps.isRounded : _this$props2$isRounde,
          rest = _objectWithoutProperties(_this$props2, ["value", "isResizeable", "size", "isRounded"]);

      return /*#__PURE__*/React__default.createElement(RawTextField, _extends({}, rest, {
        isResizeable: isResizeable,
        size: size,
        isRounded: isRounded,
        pattern: "[0-9]*",
        value: this.formatValue(value),
        onChange: this.handleChange,
        type: "number",
        __focusBehavior: "default"
      }));
    }
  }]);

  return NumberField;
}(React__default.PureComponent);

_defineProperty(NumberField, "Sizes", NumberFieldSize);

_defineProperty(NumberField, "defaultProps", _objectSpread(_objectSpread({}, RawTextDefaultProps), {}, {
  allowFloats: false
}));

export { NumberField as default };
